import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ja',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Keep as absolute but verify public folder structure
    },

    // Supported languages
    supportedLngs: ['ja', 'en', 'es', 'zh-CN', 'zh-TW', 'vi', 'fr'],

    // Force language code only (e.g. ja-JP -> ja)
    load: 'languageOnly',

    // Japanese default
    lng: 'ja',
  });

export default i18n;
